{
    "action__edit": "Edit",
    "action__copy_address": "Copy address"
}
